import { useRoute } from 'vue-router'

/**
 * Returns a guard that reports whether `id` is still the route's current `:id` param. A
 * background refresh checks this before applying its response, so a response that lands after
 * the page has navigated to a different record is dropped instead of overwriting what is now on
 * screen. Shared by TeamDetailView and RoleDetailView, whose live-refresh loops both need it.
 */
export function useRouteIdGuard(): (id: string) => boolean {
    const route = useRoute()
    return (id: string) => String(route.params.id) === id
}
